import * as React from 'react';
import withIconSvg from '../helpers/withIconSvg';

const Icon: React.FC = (props) => (
	<svg
		height="21"
		width="24"
		viewBox="0 0 24 20.5"
		{...props}
	>
		<g>
			<path className="st0" d="M16,13c-0.2,0-0.3,0-0.4-0.1L12,11.1l-3.6,1.8c-0.5,0.2-1.1,0-1.3-0.4c-0.2-0.5,0-1.1,0.4-1.3l4-2
				c0.3-0.1,0.6-0.1,0.9,0l4,2c0.5,0.2,0.7,0.8,0.4,1.3C16.7,12.8,16.4,13,16,13z"/>
		</g>
		<g>
			<path className="st0" d="M14,16c-0.2,0-0.3,0-0.4-0.1L12,15.1l-1.6,0.8c-0.5,0.2-1.1,0-1.3-0.4c-0.2-0.5,0-1.1,0.4-1.3l2-1
				c0.3-0.1,0.6-0.1,0.9,0l2,1c0.5,0.2,0.7,0.8,0.4,1.3C14.7,15.8,14.4,16,14,16z"/>
		</g>
		<g>
			<path className="st0" d="M12,20.5c-0.4,0-0.8-0.2-1.1-0.4c-0.1-0.1-0.1-0.2-0.2-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3
				c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.2-0.2c0.6-0.6,1.6-0.6,2.1,0
				c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2-0.1,0.3
				c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.2-0.2,0.2C12.8,20.3,12.4,20.5,12,20.5z"/>
		</g>
		<g>
			<path className="st0" d="M5,16c-2.8,0-5-2.2-5-5c0-2.1,1.3-3.9,3.2-4.6C3.9,2.7,7.2,0,11,0c2,0,3.9,0.7,5.3,2c0.2,0,0.5,0,0.7,0
				c3.9,0,7,3.1,7,7c0,3-1.9,5.6-4.7,6.6c-0.5,0.2-1.1-0.1-1.3-0.6c-0.2-0.5,0.1-1.1,0.6-1.3C20.7,13,22,11.1,22,9c0-2.8-2.2-5-5-5
				c-0.3,0-0.5,0-0.8,0.1c-0.3,0.1-0.7-0.1-0.9-0.3C14.1,2.6,12.6,2,11,2C8,2,5.4,4.3,5.1,7.2C5,7.7,4.7,8,4.3,8.1C2.9,8.4,2,9.6,2,11
				c0,1.7,1.3,3,3,3c0.6,0,1,0.4,1,1S5.6,16,5,16z"/>
		</g>
	</svg>
);

export default withIconSvg(
	Icon,
	true,
	{
		tags: [
			'connect',
			'host',
			'push',
			'remote',
		],
	},
);
